<template>
    <el-scrollbar class="border-container">
        <div class="img-container">
            <img class="img-100" src="../../assets/border/jxcgBorder1.jpeg" alt >
        </div>
    </el-scrollbar>
</template>

<script>
export default {
    name: "jxcgBorder",
    components: {},
    data() {
        return {};
    },
    created() {},
    activated() {},
    watch: {},
    methods: {}
};
</script>

<style scoped>
.border-container{
    width: 100%;
    height: 100%;
}
.img-container{
    width: 100%;
    height: auto;
}
</style>